module.exports = __webpack_public_path__ + "static/media/HomeFurnishing4.0dd1618c.png";